import { useThemeStore } from '@/stores/themeStore'

// Hook conveniente para acessar e modificar o tema
export function useTheme() {
  const { theme, setTheme, setMode, resetTheme } = useThemeStore()

  const toggleMode = () => {
    setMode(theme.mode === 'dark' ? 'light' : 'dark')
  }

  const isDark = theme.mode === 'dark'

  return {
    theme,
    isDark,
    setTheme,
    setMode,
    toggleMode,
    resetTheme,
  }
}
